<script lang="ts" setup>
const { locale,locales, setLocale } = useI18n()
import enIcon from '@images/lang/en2.png'
import idIcon from '@images/lang/id.png'


const changeLanguage = (code: string) => {
  setLocale(code)
}
</script>

<template>
  <div class="lang-switcher">
    <p class="lang-switcher__label text-subtitle-1 mb-2">Language :</p>
    
    <div class="d-flex gap-x-4">
      <button
        v-for="lang in locales"
        :key="lang.code"
        class="lang-button"
        :class="{ 'lang-button--active': locale === lang.code }"
        :aria-label="lang.label"
        @click="changeLanguage(lang.code)"
      >
        <div class="d-flex align-center gap-x-2">
          <VAvatar size="24">
            <VImg :src="lang.code === 'en' ? enIcon : idIcon" />
          </VAvatar>
          <span class="font-weight-medium">{{ lang.label }}</span>
        </div>
      </button>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.lang-switcher {
  &__label {
    color: #333;
  }
}

.lang-button {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: 2px solid #D9D9D9;
  border-radius: 8px;
  background-color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  outline: none;

  &--active {
    border-color: #FF1D25; // Warna merah sesuai referensi
    color: #333;
  }

  &:hover:not(&--active) {
    background-color: #f5f5f5;
  }
}
</style>
